import { render, staticRenderFns } from "./wiki_discussion_sorter.vue?vue&type=template&id=efa1f02c&vue3"
import script from "./wiki_discussion_sorter.vue?vue&type=script&lang=js&vue3"
export * from "./wiki_discussion_sorter.vue?vue&type=script&lang=js&vue3"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports